import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Styles from '../Config/Styles';
import { Grid2 } from '@mui/material';

const ContactData = [
  { name: "Call Us: ", value: "+966 11 510 1706" },
  { name: "Email: ", value: "hello@brkz.com" }
]

const Footer2 = () => {
  return (
    <Box
      component="footer"
      sx={Styles.Footer2Style.box}
    >
      <Grid2 container sx={Styles.Footer2Style.outergrid}>
        <img
          src={require("../assets/Logoblack.png")}
          alt="Tabta Logo"
          style={Styles.Footer2Style.img}
        />
        <Grid2 item sx={Styles.Footer2Style.grid2}>
          <Typography variant="body1" sx={Styles.Footer2Style.typo}>
            Get in Touch
          </Typography>
          {ContactData?.map((item, ind) => <Typography variant="body2" sx={Styles.Footer2Style.align}>
            {item.name} <Link href="tel:+966115101706" sx={Styles.Footer2Style.bold}>{item.value}</Link>
          </Typography>
          )}
        </Grid2>
      </Grid2>
      <Grid2 item xs={12} sm={4} sx={Styles.Footer2Style.bottom}>
        <Typography variant="body2" sx={Styles.Footer2Style.copyright}>
          © Copyright 2025, TABTA, All Rights Reserved.
        </Typography>
        <Box sx={Styles.Footer2Style.copyright}>
          <Link href="#" underline="none" sx={Styles.Footer2Style.link}>
            Privacy Policy
          </Link>
          <Typography variant="body2" component="span" sx={Styles.Footer2Style.seperator}>
            and
          </Typography>
          <Link href="#" underline="none" sx={Styles.Footer2Style.link}>
            Terms of Use
          </Link>
        </Box>

      </Grid2>
    </Box >
  );
};

export default Footer2;
